
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
	import Message from '@/components/message.vue';
	import Switch from '@/components/switch.vue';

  import {
    activitySignUpactivitySignUpPageInit,
    activitySignUpdelete,
    activitySignUpsortEdit,
    activitySignUpisDisplaySave
  } from "@/api/live"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate,
			'slz-message': Message,
      'slz-switch': Switch,
    }
  })

  export default class ProductList extends Vue {
    private keywords = ''
    private state = null
    private statelist = [
      {value:null,label:'全部'},
      {value:0,label:'未开始'},
      {value:1,label:'进行中'},
      {value:2,label:'已结束'},
    ]
    private pageSize = 20
    private pageNo = 1
    private total = 0
    private tablelist:any = []
    private tableloading = false
    private rowmsg:any = {}
    private delShow = false


    private mounted () {
      this.gettablelist()
    }
    private activated () {
      this.gettablelist()
    }



    private async editNum(row){
      if(!this.rowmsg.Sort&&String(this.rowmsg.Sort)!=='0'){
        this.$message.error('请输入序号')
        return
      }
      try{
        this.tableloading = true
        let res:any = await activitySignUpsortEdit({
          Id:this.rowmsg.Id,
          Sort:this.rowmsg.Sort
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
        }
      }finally{
        this.tableloading = false
      }
    }
    private getNum(row){
      this.rowmsg = JSON.parse(JSON.stringify(row))
    }
    private async changeShow(e,row){
      try{
        this.tableloading = true
        let res:any = await activitySignUpisDisplaySave({
          Id:row.Id,
          IsDisplay:e
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
        }
      }finally{
        this.tableloading = false
      }
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private clearSearch(){
      this.keywords = ''
      this.state = null
      this.doSearch()
    }
    private todetails(row){
      this.$router.push({
        path:'signup_details',
        query:{
          Id:row.Id
        }
      })
    }
    private todata(row){
      this.$router.push({
        path:'signup_data',
        query:{
          Id:row.Id,
          Name:encodeURIComponent(row.ActivityName)
        }
      })
    }
    private async confirmdel(){
      try{
        this.tableloading = true
        let res:any = await activitySignUpdelete({
          Id:this.rowmsg.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.delShow = false
          this.gettablelist()
        }
      }finally{
        this.tableloading = false
      }
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          Keywords:this.keywords,
          ActivityState:this.state,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        let res:any = await activitySignUpactivitySignUpPageInit(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results.map(v=>{
            v.editShow = false
            return v
          })
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private detele(row){
      this.rowmsg = row
      this.delShow = true
    }
  }
